const STORAGE_KEY = 'hotArticleQueue';

const MAX_CLICKS = 30; // 클릭한 인기글 최대 갯수: 30
const MAX_VIMPS = 100; // 본 인기글 최대 갯수: 100
const MAX_TIME = 30 * 60 * 1000; // 데이터 유지 시간: 30분

function getQueue() {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		if (!raw) return { clicks: new Set(), vimps: new Set(), createdAt: Date.now() };
		const parsed = JSON.parse(raw);

		if (MAX_TIME <= Date.now() - parsed.createdAt) {
			localStorage.removeItem(STORAGE_KEY);
			return { clicks: new Set(), vimps: new Set(), createdAt: Date.now() };
		}

		return {
			clicks: new Set(parsed.clicks || []),
			vimps: new Set(parsed.vimps || []),
			createdAt: parsed.createdAt || Date.now()
		};
	} catch (e) {
		return { clicks: new Set(), vimps: new Set(), createdAt: Date.now() };
	}
}

function saveQueue(queue) {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify({
			clicks: [...queue.clicks],
			vimps: [...queue.vimps],
			createdAt: queue.createdAt
		}));
	} catch (e) { /* 저장 실패 시 무시 */ }
}

export function addClick(itemId) {
	const queue = getQueue();
	if (!queue.clicks.has(String(itemId)) && queue.clicks.size >= MAX_CLICKS) {
		queue.clicks.delete(queue.clicks.values().next().value);
	}
	queue.clicks.add(String(itemId));
	saveQueue(queue);
}

export function addVimps(itemIds) {
	const queue = getQueue();
	if(itemIds.length === 0) return;

	itemIds.forEach(itemId => {
		const id = String(itemId);

		//중복이면 최신 순서로 갱신
		if(queue.vimps.has(id)) {
			queue.vimps.delete(id);
		} else if(queue.vimps.size >= MAX_VIMPS) {
			queue.vimps.delete(queue.vimps.values().next().value);
		}

		queue.vimps.add(id);
	});

	saveQueue(queue);
}

export function getQueueData() {
	const queue = getQueue();
	return {
		clickItems: [...queue.clicks],
		vimpItems: [...queue.vimps]
	}
}
